import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '.';

export interface ISalesItemOptionTagAlongListingModel extends IModel {
  salesItemOptionTagAlongId: number;
  salesItemOptionId: number;
  tagAlongSalesItemOptionId: number;
  tagAlongSalesItemOptionName: string;
  tagAlongSalesItemOptionDisplayName: string;
  tagAlongSalesItemId: number;
  tagAlongSalesItemName: string;
  tagAlongSalesItemDescription: string;
  tagAlongSalesItemSalesSubCategoryId: number;
}

export class SalesItemOptionTagAlongListingModel
  extends Model
  implements ModelRecord<ISalesItemOptionTagAlongListingModel>
{
  salesItemOptionTagAlongId: number;
  salesItemOptionId: number;
  tagAlongSalesItemOptionId: number;
  tagAlongSalesItemOptionName: string;
  tagAlongSalesItemOptionDisplayName: string;
  tagAlongSalesItemId: number;
  tagAlongSalesItemName: string;
  tagAlongSalesItemDescription: string;
  tagAlongSalesItemSalesSubCategoryId: number;

  constructor(params?: Partial<ISalesItemOptionTagAlongListingModel>) {
    super(params);
    this.salesItemOptionTagAlongId = defaultTo(
      params?.salesItemOptionTagAlongId,
      0,
    );
    this.salesItemOptionId = defaultTo(params?.salesItemOptionId, 0);
    this.tagAlongSalesItemOptionId = defaultTo(
      params?.tagAlongSalesItemOptionId,
      0,
    );
    this.tagAlongSalesItemOptionName = defaultTo(
      params?.tagAlongSalesItemOptionName,
      '',
    );
    this.tagAlongSalesItemOptionDisplayName = defaultTo(
      params?.tagAlongSalesItemOptionDisplayName,
      '',
    );
    this.tagAlongSalesItemId = defaultTo(params?.tagAlongSalesItemId, 0);
    this.tagAlongSalesItemName = defaultTo(params?.tagAlongSalesItemName, '');
    this.tagAlongSalesItemDescription = defaultTo(
      params?.tagAlongSalesItemDescription,
      '',
    );
    this.tagAlongSalesItemSalesSubCategoryId = defaultTo(
      params?.tagAlongSalesItemSalesSubCategoryId,
      0,
    );
  }
}
